<template>
  <div class="pt-4 pb-4 d-flex align-center">
    <v-text-field
      label="Insira a URL da imagem"
      autofocus
      v-model="url"
      outlined
      hide-details
      dense
      placeholder="https://..."
    ></v-text-field>
    <v-btn class="ml-3" style="width: 150px;" @click="save()" depressed dark color="#803BE8">Aplicar</v-btn>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: ''
    }
  },
  methods: {
    save () {
      this.$emit('save', this.url)
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>